import styled, { css } from 'styled-components'
import media from '../../../../services/generateMediaQueries'

// assets
import rewardsBanner from '../../../../assets/img/rewards/rewardsBanner.webp'
import ZingLogo from '../../../../assets/img/zing.svg'
import ZingIcon from '../../../../assets/img/zing-icon.svg'

// components
import LinkButton from '../../../../components/ui/LinkButton/LinkButton'
import CatalogList from '../../../../components/home/CatalogList/CatalogList'
import TextInput from '../../../../components/ui/TextInput/TextInput'
import CatalogCard from '../../../../components/home/CatalogCard/CatalogCard'
import CatalogPicker from '../../../../components/home/CatalogPicker/CatalogPicker'

export const StyledLink = styled.div`
  text-decoration: none;

  width: calc(33% - 1rem);
  height: 300px;
  margin: 0.5rem;
  cursor: pointer;

  ${media.lessThan('small')`
  width: calc(100% - 1rem);
  height: 100px;
  margin: 0.5rem;
  box-sizing: border-box;
  padding: 0px;
`}
`

export const ErrorCard = styled.div`
  /* text-decoration: none; */

  width: calc(33% - 1rem);
  height: 300px;
  margin: 0.5rem;

  background: linear-gradient(
      rgba(141, 122, 157, 0.4),
      rgba(141, 122, 157, 0.4)
    ),
    #f9f9f9;
  border-radius: var(--border-radius-card);
  display: flex;
  justify-content: center;
  align-items: center;

  ${media.lessThan('small')`
  width: calc(100% - 1rem);
  height: 100px;
  margin: 0.5rem;
  box-sizing: border-box;
  padding: 0px;
  h1 {
    text-align: center;
  }
`}
`

export const StyledBanner = styled.div.attrs(() => ({
  style: {
    background: `linear-gradient(
    to bottom right,
    rgba(231, 71, 94, 0.95) 0%,
    rgba(235, 118, 50, 0.95) 100%
  ), url('${rewardsBanner}') top / cover no-repeat`,
  },
}))`
  width: 100%;
  height: 530px;

  ${media.lessThan('small')`
  height: 480px;
  margin-top: -40px;
  /* padding-top: 10px; */
`}
`

export const BannerContent = styled.div`
  width: 100%;
  max-width: 1024px;
  height: 430px;
  margin: 0 auto;

  display: flex;
  align-items: center;
`

export const BannerDescription = styled.div`
  width: 100%;
  padding: 0 1rem;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  color: #ffffff;
`

export const Heading = styled.div`
  /* margin-top:  !important; */
  ${media.lessThan('large')`
  padding: 0 1.5rem;
`}

  ${media.lessThan('small')`
  padding: 0 1rem;
`}
`

export const Content = styled.div`
  margin-top: 4rem;

  ${media.lessThan('medium')`
  margin-top: 0rem;
`}
`

export const FormContainer = styled.div`
  display: flex;
  margin-top: -6rem;
  width: 75%;
  margin: auto;

  ${media.lessThan('medium')`
  margin-top: -10.9rem;
  flex-wrap: wrap;
  width: 100%;
`}
`

export const StyledCatalogList = styled(CatalogList)`
  ${media.lessThan('large')`
  margin: 0 1rem;
  justify-content: space-around;
`}

  ${media.lessThan('small')`
  flex-direction: column;
  color: unset;
  padding: 0;
  justify-content: space-between;
  margin: 1rem;
`}
`

export const StyledCatalogCard = styled(CatalogCard)`
  margin: 0 0.5rem;
  margin-bottom: 1rem !important;

  ${media.lessThan('small')`
  margin: 0;
`}
`

export const StyledCatalogPicker = styled(CatalogPicker)`
  flex: 1;
  margin-right: 1rem;
`

export const RewardsCatalogTitle = styled.h2`
  font-size: 2rem;
  margin: 0;
  text-transform: uppercase;
  text-align: center;

  ${media.lessThan('small')`
  font-size: 1.375rem;
`}
`

export const RewardsCatalogDescription = styled.p`
  font-size: 1.5rem;
  margin: 1rem 0 2rem;
  text-align: center;

  ${media.lessThan('small')`
  font-size: 1.125rem;
`}
`

export const StyledZingLogo = styled.img.attrs({ src: ZingLogo })`
  display: none;

  ${media.lessThan('small')`
  display: block;
`}
`

export const StyledTextInput = styled(TextInput)`
  /* background-color: white;
border: none; */
  /* padding: 0.5rem 1rem; */
  border-radius: var(--border-radius-form);
  box-shadow: 0px 8px 10px 0px rgba(0, 0, 0, 0.05);
  border: 1px solid #fff !important;
  width: 100%;
  /* margin-top: 0.45rem; */
  color: #fff !important;

  &::placeholder {
    opacity: 1;
    color: #fff !important;
  }
  &:hover {
    color: #fff !important;
    border: 1px solid #fff !important;
    &::placeholder {
      opacity: 1;
      color: #fff !important;
    }
  }

  ${media.lessThan('medium')`
  opacity: 80%;
  margin-top: 0.45rem;
`} /* &::placeholder {
  opacity: 1;
  color: #fff;
} */
`

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-left: 1rem;
  box-sizing: border-box;
  /* flex: 2; */
  background-color: transparent;
  /* border-radius: var(--border-radius-form); */
  /* box-shadow: 0px 8px 10px 0px rgba(0, 0, 0, 0.05); */
  /* color: #fff; */
  width: calc(50% - 1.5rem);
  padding: 0px;

  ${media.lessThan('medium')`
  flex: unset;
  width: 100%;
  margin-left: 0px;
  /* width: calc(50% - 1.5rem) !important; */
  transition: all var(--animation-duration) var(--animation-easing);
  height: 3rem;
  margin-bottom: 1rem;

  &:hover {
    /* flex: 1; */
    /* width: calc(50% - 1.5rem) !important; */
    transition: all var(--animation-duration) var(--animation-easing);

    ${StyledTextInput} {
      padding-left: 1rem;
    }
  }
`}
`

export const ShopLinkButton = styled(LinkButton)`
  background-color: var(--color-bg-form);
  color: var(--color-secondary) !important;

  &:hover {
    background-color: var(--color-bg-form);
    color: var(--color-secondary-hover) !important;
  }
`

export const DineLinkButton = styled(LinkButton)`
  background-color: var(--color-primary);
  color: var(--color-bg-form) !important;

  &:hover {
    background-color: var(--color-primary);
  }
`

export const StyledShopDineCard = styled.div`
  border-radius: var(--border-radius-card);
  height: 100%;
  background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.8)),
    linear-gradient(rgba(141, 122, 157, 0.4), rgba(141, 122, 157, 0.4)),
    linear-gradient(#000000, #000000);

  ${props =>
    props.cardImageUrl &&
    css`
    background: linear-gradient(to bottom , transparent, rgba(0, 0, 0, 0.8)), linear-gradient(rgba(141,122,157,0.40), rgba(141,122,157,0.40)), url('${props.cardImageUrl}') 0% 0% / cover, linear-gradient(#000000, #000000);
    backgroundSize: 'cover';
    backgroundPosition: 'center';
  `}

  ${media.lessThan('small')`
  background: unset;
  background-color: #fff;
`}
`

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1.5rem 2.5rem;
  height: 100%;
  border-radius: var(--border-radius-card);
  color: #ffffff;
  text-align: center;
  z-index: 1;

  ${media.lessThan('small')`
  flex-direction: row;
  padding: 0;
  align-items: center;
  height: 100px;
  box-sizing: border-box;
  overflow: hidden;
`}
`

export const LogoContainer = styled.div`
  ${media.lessThan('small')`
  width: 100px;
  padding: 0px;
  /* margin: 0; */
  margin-left: -1rem;

  ${props =>
    props.cardImageUrl &&
    css`
      background: linear-gradient(to bottom , transparent, rgba(0, 0, 0, 0.8)), linear-gradient(rgba(141,122,157,0.40), rgba(141,122,157,0.40)), url('${props.cardImageUrl}') 0% 0% / cover, linear-gradient(#000000, #000000);
      backgroundSize: 'cover';
      backgroundPosition: 'center';
      border-top-left-radius: 0.3125rem;
      border-bottom-left-radius: 0.3125rem;
    `}
`}
`

export const Logo = styled.img`
  border: 0px;
  border-radius: 0.3125rem;
  height: 3.6875rem;
  width: 3.6875rem;
  margin: 2rem auto;
  object-fit: contain;

  ${props =>
    props.src == null &&
    css`
      background-color: #000;
      border: 0px;
    `}

  ${media.lessThan('small')`
  padding: auto;
  box-sizing: border-box;
  /* margin: auto; */
`}
`

export const LogoFiller = styled.div`
  height: 3.6875rem;
  width: 3.6875rem;
  margin: 2rem auto;
  background-color: transparent;
`

export const Title = styled.h1`
  font-size: 1.25rem;
  line-height: 1.75rem;
  letter-spacing: 0.28px;
  font-weight: var(--font-weight-boldest);
  letter-spacing: 0.28px;
  margin: 0;
  text-transform: uppercase;
  text-align: center;

  ${media.lessThan('small')`
  width: calc(100% - 100px - 1rem);
  text-align: left;
  color: var(--color-fg);
  padding-left: 1rem;
  box-sizing: border-box;
`}
`

export const CardImage = styled.div`
  /* position: absolute;
top: 0;
bottom: 0;
right: 0;
left: 0; */
  border-radius: var(--border-radius-card);
  background-color: #000000;
  transition: all 0.5s;
  width: 100%;
  height: 100%;
`
export const SelectMallButton = styled.button`
  display: flex;
  /* flex: 1 1 375px; */
  justify-content: space-between;
  align-items: center;
  color: #ffffff;
  background: transparent;
  height: 3rem;
  border: 1px solid #ffffff;
  border-radius: 4px;
  padding: 0 1rem;
  width: calc(50% - 1.5rem);

  ${media.lessThan('medium')`
  width: 100%;
/* width: calc(50% - 1.5rem); */
  /* flex: 0 0 auto; */
  margin-bottom: 1rem;
`}
`

export const ZingIconComponent = styled.img.attrs({ src: ZingIcon })`
  margin-bottom: 1rem;

  ${media.lessThan('small')`
  flex: 0 0 auto;
  padding: 1.25rem;
  margin-bottom: 0;
`}
`
